module.exports = __webpack_public_path__ + "img/jordan-arnold-Ul07QK2AR-0-unsplash.1f2297b6.jpeg";